let baseUrlq = '' // 接口URL
let baseUrlx = '' // 接口URL
let pageUrl = '' // 企业端网址

// switch (location.hostname) {
//     // 本地环境url
//     case 'localhost':
//         // baseUrl = "https://test_api.zjtoutiao.cn/";
//         baseUrl = "https://api.qxiaoyun.com/"; 
//         pageUrl = 'https://www.baidu.com'
//         break;
//     default:
//         baseUrl = "https://api.qxiaoyun.com/";
//         pageUrl = 'https://www.baidu.com'

// }
baseUrlq = "https://api.qxiaoyun.com/"
baseUrlx = "https://api.xixunyun.com/" 
export {
    baseUrlq, baseUrlx, pageUrl
};